/* global Shopify, jQuery */
(function ($) {
  /* --------------------------------------------------------------------------
   * Helpers
   * ----------------------------------------------------------------------- */
  const formatMoney = (cents) =>
    Shopify.formatMoney(cents, window.money_format);
  const $doc = $(document);

  window.handleize = function (input) {
    // 1) Garanta que sempre temos uma string (evita ler "normalize" de undefined/null)
    const str = input == null ? "" : String(input);

    // 2) Remova diacríticos de forma segura: usa normalize se existir; senão, cai para um fallback simples (PT/latin)
    const hasNormalize = typeof String.prototype.normalize === "function";
    const base = hasNormalize ? str.normalize("NFD") : str;

    // Fallback para navegadores sem normalize: cobre acentos mais comuns em PT
    const deburred = hasNormalize
      ? base
      : base
          .replace(/[áàâãäå]/gi, "a")
          .replace(/[éêèë]/gi, "e")
          .replace(/[íìîï]/gi, "i")
          .replace(/[óòôõö]/gi, "o")
          .replace(/[úùûü]/gi, "u")
          .replace(/[ç]/gi, "c")
          .replace(/[ñ]/gi, "n");

    return deburred
      // Remover marcas diacríticas combinantes (funciona após NFD)
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim()
      // Permitir apenas letras, números, espaços e hífens
      .replace(/[^a-z0-9\s-]/g, "")
      // Espaços -> hífen
      .replace(/\s+/g, "-")
      // Colapsar múltiplos hífens
      .replace(/-+/g, "-");
  };

  /* --------------------------------------------------------------------------
   * Shipping-calculator module
   * ----------------------------------------------------------------------- */
  const Shipping = (() => {
    /* Cached selectors */
    const els = {
      inputCep: () => $(".zipcode-input"),
      list: () => $(".shipping_options__list"),
      listWrap: () => $(".cart-drawer__footer__shipping_options"),
      displayWrap: () => $(".shipping-display__wrapper"),
      shipName: () => $(".shipping-rate-name"),
      shipPrice: () => $(".shipping-display.value"),
      total: () => $("[data-cart-total-value]"),
      overlay: () => $(".overlay-carregando"),
      btnCalc: () => $(".calculate-shipping"),
      btnChange: () => $(".recalculate-shipping"),
      error: () => $(".erro-shipping"),
    };

    /* UF → Estado map */
    const UF = {
      AC: "Acre",
      AL: "Alagoas",
      AP: "Amapá",
      AM: "Amazonas",
      BA: "Bahia",
      CE: "Ceará",
      DF: "Distrito Federal",
      ES: "Espírito Santo",
      GO: "Goiás",
      MA: "Maranhão",
      MT: "Mato Grosso",
      MS: "Mato Grosso do Sul",
      MG: "Minas Gerais",
      PA: "Pará",
      PB: "Paraíba",
      PR: "Paraná",
      PE: "Pernambuco",
      PI: "Piauí",
      RJ: "Rio de Janeiro",
      RN: "Rio Grande do Norte",
      RS: "Rio Grande do Sul",
      RO: "Rondônia",
      RR: "Roraima",
      SC: "Santa Catarina",
      SP: "São Paulo",
      SE: "Sergipe",
      TO: "Tocantins",
    };

    const error = (msg) => {
      const $container = els.inputCep().closest(".cart-drawer__footer__row");
      els.inputCep().val("");
      $container.addClass("error-input");
      els.error().text(msg);
      setTimeout(() => {
        $container.removeClass("error-input");
        els.error().empty();
      }, 4000);
    };

    const requestRates = (cep, uf) => {
      $.ajax({
        url:
          `/cart/shipping_rates.json` +
          `?shipping_address[zip]=${cep}` +
          `&shipping_address[country]=Brazil` +
          `&shipping_address[province]=${uf}`,
        dataType: "json",
        beforeSend: () => els.overlay().show(),
      })
        .done(renderRates)
        .fail(() => console.error("Erro ao consultar os fretes disponíveis."))
        .always(() => els.overlay().hide());
    };

    const renderRates = ({ shipping_rates: rates }) => {
      const $list = els.list().empty();

      rates.forEach((rate) => {
        const formatted = rate.price === 0 ? "Grátis" : formatMoney(rate.price);
        // const delivery = rate.delivery_days?.[1]
        //   ? `( Em até ${rate.delivery_days[1]} dias úteis )`
        //   : "";
        let delivery = "";
        if (rate.delivery_days && rate.delivery_days.length > 1) {
          delivery = `( Em até ${rate.delivery_days[1]} dias úteis )`;
        } else if (rate.description) {
          delivery = `(${rate.description})`;
        }
        const safeName = rate.name
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/(^-|-$)/g, "");

        const li = `<li data-shipping-change class="filters-group__list__item">
				<label class="filters-checkbox" for="shipping-option_${safeName}">
				  <input type="radio" id="shipping-option_${safeName}"
						 name="shipping_id"
						 data-name="${rate.name}"
						 data-price="${rate.price}"
						 data-formatted-price="${formatted}"
						 data-delivery="${delivery}">
				  <span class="check"></span>
				  <span class="text">${rate.name} - ${formatted} ${delivery}</span>
				</label>
			 </li>`;
        $list.append(li);
      });

      els.listWrap().removeClass("hidden");
    };

    const onCalcClick = () => {
      const cep = els.inputCep().val().replace(/\D/g, "");
      const validCep = /^[0-9]{8}$/;

      if (!cep) return error("Campo CEP está vazio");
      if (!validCep.test(cep)) return error("CEP inválido");

      $.getJSON(`https://viacep.com.br/ws/${cep}/json/?callback=?`, (data) => {
        if (data.erro) return error("CEP não encontrado");
        requestRates(cep, UF[data.uf] || data.uf);
      });
    };

    const onChoose = (input) => {
      const priceCents = Number(String(input.data("price")).replace(".", ""));
      const subtotal = Number($("[data-cart-subtotal]").data("cart-subtotal"));
      els.total().html(formatMoney(subtotal + priceCents));

      els.shipName().text(input.data("name"));
      els.shipPrice().text(input.data("formatted-price") + " " + input.data("delivery"));

      els.displayWrap().removeClass("hidden");
      els.listWrap().addClass("hidden");
      els.btnCalc().addClass("hidden");
      els.btnChange().removeClass("hidden");
    };

    const reset = () => {
      els.listWrap().addClass("hidden");
      els.displayWrap().addClass("hidden");
      els.btnChange().addClass("hidden");
      els.btnCalc().removeClass("hidden");
      els.inputCep().val("").focus();
    };

    /* Public: wire listeners */
    const init = () => {
      $doc
        .on("click", ".calculate-shipping", onCalcClick)
        .on("click", ".recalculate-shipping", reset)
        .on("click", "[data-shipping-change]", (e) =>
          onChoose($(e.currentTarget).find("input"))
        )
        .on("input", ".zipcode-input", function () {
          if (!this.value) reset();
        })
        .on("click", ".show-rates-list", () =>
          els.listWrap().removeClass("hidden")
        );
    };

    return { init };
  })();

  /* --------------------------------------------------------------------------
   * “Copy coupon” module
   * ----------------------------------------------------------------------- */

  const Clipboard = (() => {
    const copy = (el) => {
      // se não tiver armazenado o cupom original, guarda agora
      if (!$(el).data("original-cupom")) {
        $(el).data("original-cupom", $(el).text());
      }

      const cupom = $(el).data("original-cupom");

      navigator.clipboard.writeText(cupom);
      $(el).text("COPIADO");

      setTimeout(() => {
        $(el).text(cupom);
      }, 600);
    };

    const init = () => $doc.on("click", "cupom", (e) => copy(e.currentTarget));

    return { init };
  })();

  /* --------------------------------------------------------------------------
   * Bundle-price module
   * ----------------------------------------------------------------------- */
  const Bundle = (() => {
    const selectors = {
      item: ".product-item-bundle",
      checkbox: ".product-item-bundle__checkbox",
      price: ".bundle-price-total .bundle-price",
      compare: ".bundle-price-total .bundle-price-compare",
    };

    const calcTotals = () => {
      let subtotal = 0;
      let compare = 0;

      document.querySelectorAll(`${selectors.item}.checked`).forEach((card) => {
        const price = Number(card.dataset.price);
        const compareAt = Number(card.dataset.compareAtPrice) || price;
        subtotal += price;
        compare += compareAt;
      });

      $(selectors.price).text(formatMoney(subtotal));
      $(selectors.compare).text(subtotal < compare ? formatMoney(compare) : "");
    };

    const addBundleToCart = async () => {
      const items = [
        ...document.querySelectorAll(`${selectors.item}.checked`),
      ].map((card) => ({ id: card.dataset.variant, quantity: 1 }));
      if (!items.length) return;

      try {
        await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items }),
        });
        document.body.classList.remove("bundle-sidebar-show");
        Shopify.getCart((c) => window.updateCart(c));
      } catch (err) {
        console.error("Erro ao adicionar bundle:", err);
      }
    };

    const init = () => {
      $doc.on("change", selectors.checkbox, function () {
        $(this).closest(selectors.item).toggleClass("checked");
        calcTotals();
      });
      $doc.on("click", ".add-bundle", (e) => {
        e.preventDefault();
        addBundleToCart();
      });
      $doc.on(
        "click",
        ".halo-sidebar-close[data-close-bundle-sidebar]",
        (e) => {
          e.preventDefault();
          document.body.classList.remove("bundle-sidebar-show");
        }
      );
    };

    return { init };
  })();

  /* --------------------------------------------------------------------------
   * Front-end/Logic fixes module
   * ----------------------------------------------------------------------- */
  const LittleFixes = (() => {
    // * Previne `.menu-item` de aumentar de tamanho durante hover ou focus.
    const lockMenuItemWidth = () => {
      $(".menu-lv-1__action span").each(function () {
        $(this).css("width", $(this).width());
        $(this).css("height", $(this).height());
      });
    };

    /** Public – wire / run everything needed */
    const init = () => { };

    return { init };
  })();

  const CartFunctionalities = (() => {
    const init = () => {
      $(document).on("click", ".button-continue-buying", (event) => {
        event.preventDefault();
        event.stopPropagation();

        if ($("body").hasClass("cart-sidebar-show")) {
          $("body").removeClass("cart-sidebar-show");
        }
      });

      $(document).on("change", ".cart-item-selection-input", (event) => {
        let price = 0;
        let compareAtPrice = 0;
        const selectedLines = document.querySelectorAll(
          ".cart-item-selection-input:checked"
        );
        selectedLines.forEach((line) => {
          price += parseInt(line.dataset.quantity * line.dataset.price);
          if (line.dataset.compareAtPrice > line.dataset.price) {
            compareAtPrice += parseInt(
              line.dataset.quantity * line.dataset.compareAtPrice
            );
          } else {
            compareAtPrice += parseInt(
              line.dataset.quantity * line.dataset.price
            );
          }
        });

        const subtotal = document.querySelector("[data-cart-subtotal]");
        subtotal.dataset.cartSubtotal = price;
        subtotal.textContent = formatMoney(price);

        const total = document.querySelector("[data-cart-total-value]");
        total.dataset.cartTotalValue = price;
        total.textContent = formatMoney(price);

        const freeShippingComponent = document.querySelector(
          "free-shipping-component"
        );

        freeShippingComponent.calculateProgress(price);
      });
    };
    return { init };
  })();

  const ProductCard = (() => {
    const init = () => {
      const MONEY_FORMAT = window.money_format || "${{amount}}";
      const WRAPPER_SELECTOR = ".price__last";
      const handledWrappers = new WeakSet(); // prevent double-binding

      /** Format & correct a single wrapper ------------------------------- */
      function syncWrapper(wrapper) {
        const item = wrapper.querySelector(".price-item");
        if (!item || !wrapper.dataset.last) return;

        const expected = Shopify.formatMoney(
          Math.ceil(wrapper.dataset.last),
          MONEY_FORMAT
        );

        if (item.textContent.trim() !== expected) {
          item.textContent = expected;
        }
      }

      /** Attach a MutationObserver to one wrapper ------------------------ */
      function observeWrapper(wrapper) {
        if (handledWrappers.has(wrapper)) return; // already handled
        handledWrappers.add(wrapper);

        // Initial correction
        syncWrapper(wrapper);

        // React to *anything* inside the wrapper that could desync it
        const mo = new MutationObserver(() => syncWrapper(wrapper));
        mo.observe(wrapper, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ["data-last"], // only watch this attr
        });
      }

      /** Handle wrappers that exist on first load ----------------------- */
      document.querySelectorAll(WRAPPER_SELECTOR).forEach(observeWrapper);

      /** Handle wrappers that get injected later (quick-view, etc.) ----- */
      const pageObserver = new MutationObserver((muts) => {
        muts.forEach((m) => {
          m.addedNodes.forEach((node) => {
            if (!(node instanceof HTMLElement)) return;

            // Node *is* a wrapper
            if (node.matches && node.matches(WRAPPER_SELECTOR)) {
              observeWrapper(node);
            }

            // Node *contains* wrappers deeper inside
            node.querySelectorAll?.(WRAPPER_SELECTOR).forEach(observeWrapper);
          });
        });
      });
      pageObserver.observe(document.body, { childList: true, subtree: true });
    };

    return { init };
  })();

  /* --------------------------------------------------------------------------
   * Global initialiser
   * ----------------------------------------------------------------------- */
  const App = (() => {
    const init = () => {
      Shipping.init();
      Clipboard.init();
      Bundle.init();
      LittleFixes.init();
      CartFunctionalities.init();
      ProductCard.init();
    };
    return { init };
  })();

  /* Kick-off when the DOM is ready */
  $(App.init);
  






document.addEventListener('DOMContentLoaded', () => {
  // Toggle "O que vai na embalagem" sempre ativo
  document.querySelectorAll('a.toggleLink.show-mobile').forEach(link => {
    link.classList.add('is-open');
    link.setAttribute('aria-expanded', 'true');

    const selector = link.getAttribute('href');
    if (selector) {
      const content = document.querySelector(selector);
      if (content) content.style.display = 'block';
    }
  });

  // Desativar botões "esgotado"
  ['#product-add-to-cart', '#product-sticky-add-to-cart'].forEach(sel => {
    const btn = document.querySelector(sel);
    if (btn && btn.textContent.trim().toLowerCase() === 'esgotado') {
      btn.style.cssText = 'opacity:0.5;cursor:not-allowed;pointer-events:none;';
      btn.disabled = true;
    }
  });

  // Redirecionar para login da Yampi
  const linkDestino = 'https://seguro.vianelli.com.br/minha-conta/login';

  // Ícones principais de login
  document.querySelectorAll(
    '.header-mobile__item.header-mobile__item--customer, .header__icon.header__icon--account.link.link--text.text-center'
  ).forEach(el => {
    el.style.cursor = 'pointer';
    el.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = linkDestino;
    });
  });

  // Itens de menu "Meu perfil" e "Meus pedidos"
  document.querySelectorAll('span.text').forEach(span => {
    const texto = span.textContent.trim().toLowerCase();
    if (texto === 'meu perfil' || texto === 'meus pedidos') {
      const alvo = span.closest('a, div, li');
      if (alvo) {
        alvo.style.cursor = 'pointer';
        alvo.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = linkDestino;
        });
      }
    }
  });
});

  // Centralizar stories e tirar barrinha de scroll
  document.addEventListener("DOMContentLoaded", function () {
    const wrapper = document.querySelector(".product-stories-wrapper");

    if (wrapper) { // só roda se existir
      const items = wrapper.querySelectorAll(".product-story");

      if (items.length > 0) {
        const middleIndex = Math.floor(items.length / 2);
        const middleItem = items[middleIndex];
        const offset =
          middleItem.offsetLeft -
          (wrapper.clientWidth / 2 - middleItem.clientWidth / 2);

        wrapper.scrollLeft = offset;
      }
    }
  });
})(jQuery);